<template>
  <div class="profile-property__input-inner">
    <input
      type="text"
      class="profile-property__input common"
      v-input-mask data-inputmask-mask="+7 (999) 999 99 99"
      v-model="val"
      :class="{'input__error': !isValid}">
  </div>
</template>

<script>
  import Parent from './Parent'

  export default {
    name: 'Phone',
    mixins: [Parent]
  }
</script>



// WEBPACK FOOTER //
// src/components/Personal/PersonalProfile/Inputs/Phone.vue